import { useState, useMemo } from "react";
// Import the Model
import { REGULATORY_DATA } from "../models/CTISProjectModel";

export const useCTISProjectController = () => {
  const [projects, setProjects] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: 'submissionDate', direction: 'asc' });
  const itemsPerPage = 10;

  // Controller Method: Registering a new dossier
  const registerNewDossier = (formData) => {
    const projectRecord = {
      ...formData,
      id: `PROJ-${new Date().getFullYear()}-${String(projects.length + 1).padStart(3, '0')}`,
      status: formData.status || "Pending",
      readiness: 0
    };
    setProjects(prev => [...prev, projectRecord]);
  };

  const viewModel = useMemo(() => {
    let items = [...projects];
    items.sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'asc' ? -1 : 1;
      if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });

    return {
      paginatedItems: items.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage),
      totalPages: Math.ceil(items.length / itemsPerPage)
    };
  }, [projects, sortConfig, currentPage]);

  return {
    projects: viewModel.paginatedItems,
    totalPages: viewModel.totalPages,
    currentPage,
    setCurrentPage,
    registerNewDossier,
    handleSort: (key) => setSortConfig(prev => ({ 
      key, direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc' 
    })),
    sortConfig,
    // Provide the Model data to the View through the Controller
    regulatoryDNA: REGULATORY_DATA 
  };
};